import useTranslation from "hooks/useTranslation";
import { Puff } from "react-loader-spinner";
import { getNotifMsg } from "utils/message";

function ConversationPageLoader() {
  const { getAppLocale } = useTranslation(["CHAT", "COMMON"]);
  const locale = getAppLocale();

  return (
    <div className="loader_container">
      <Puff
        height="80"
        width="80"
        radius="9"
        color="#b10e84"
        ariaLabel="three-dots-loading"
      />
      <div className="loader_container__text">
        <span>{getNotifMsg("SETTING_UP_APP", locale)}</span>
      </div>
    </div>
  );
}

export default ConversationPageLoader;
